import { css } from "@linaria/core";

export const scrambled = css`
  position: relative;

  padding-bottom: 56.25%;

  height: 0;
  width: 100%;

  background-color: #eee;
`;

export const container = css`
  position: absolute;
  inset: 0;

  overflow: hidden;
`;

export const icon = css`
  position: absolute;
  right: 0;
  bottom: 0;
  z-index: 0;

  height: auto;
  width: 41%;

  display: block;

  opacity: 0.1;
  transform: translateX(5%) translateY(9%);
`;
